module.exports = __webpack_public_path__ + "static/media/smart-letter-logo-white.93f3029b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smart-letter-logo-white.svg
// module id = 1322
// module chunks = 1